module.exports = __webpack_public_path__ + "static/media/plate.39499797.mp3";